import React, { ReactElement, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './label.module.css';

export type LabelProps = React.HTMLAttributes<HTMLSpanElement> & {
  type?: 'span' | 'label'
  id?: string,
  label?: string | ReactNode,
  labelIcon?: ReactElement
  hideLabel?: boolean,
  hideOptionnal?: boolean,
  required?: boolean,
  className?: string
}

export const Label = ({type = 'label', label, labelIcon, hideLabel, hideOptionnal, id, required = false, className, ...props}: LabelProps) => {

  const Component = type

  return (
    <Component {...(type === 'label' ? {htmlFor: id}:{})} className={clsx(styles.label, hideLabel && 'sr-only', className)} {...props}>
      {label}
      {labelIcon && <span className={styles.icon}>{labelIcon}</span>}
      {!required && !hideOptionnal && <span className={styles.optionnal}>optionnel</span>}
    </Component>
  )
};
